import React from 'react';
import { RuleSet } from 'styled-components';
import { Currency } from './styled';
import { getSymbolFromCurrency } from '../../../utils/helpers/getSymbolFromCurrency';
import ManatIcon from '../../../public/static/images/currency/manat-brown.svg';
import Icon from '../../Icon';

export const CurrencySymbol = ({
  currency,
  iconStyles
}: {
  currency: string;
  iconStyles?: RuleSet<object>;
}) => (
  <Currency $currency={currency} $iconStyles={iconStyles}>
    {currency === 'AZN' ? (
      <Icon IconComponent={ManatIcon} width={11} height={11} />
    ) : (
      getSymbolFromCurrency(currency)
    )}
  </Currency>
);
